/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useSamplingContext from '../context/useSamplingContext';

function Table() {
  //
  const {
    setFilterForm,
    filterForm,
    defaultFilter,
    reportData,
    setReportData,
    totalData,
    setTotalData,
    getData,
    loading,
  } = useContext(useSamplingContext);

  const initialColumns = [
    { field: 'area_manager_name', headerName: 'RMPM', minWidth: 200, sortable: false },
    { field: 'manager_name', headerName: 'DMPM', minWidth: 200, sortable: false },
    { field: 'rep_name', headerName: 'MPR Name', minWidth: 200, sortable: false },
    { field: 'team', headerName: 'Team', minWidth: 110, sortable: false },
    { field: 'md_code', headerName: 'MD Code', minWidth: 200, sortable: false },
    { field: 'md', headerName: 'MD Name', minWidth: 200, sortable: false },
    { field: 'specialty', headerName: 'MD Specialty', minWidth: 200, sortable: false },
  ];

  const productColumns =
    reportData.length > 0
      ? Object.keys(reportData[0])
          .filter((key) => key.startsWith('product_name_'))
          .map((nameKey) => {
            const productKey = nameKey.replace('product_name_', 'product_');
            return {
              field: productKey,
              headerName: reportData[0][nameKey],
              minWidth: 100,
              sortable: false,
            };
          })
      : [];

  const columns = [...initialColumns, ...productColumns];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '650px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            pagination
            disableColumnFilter
            disableColumnSorting
            pageSize={10}
            rows={reportData}
            columns={columns}
            loading={loading}
            initialState={{
              pinnedColumns: {
                left: [
                  'area_manager_name',
                  'manager_name',
                  'rep_name',
                  'team',
                  'md_code',
                  'md',
                  'specialty',
                ],
              },
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
export default Table;
